import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { LoginCredential } from './motes-login.models';
import { LoginUser, MotesPaths } from '../models';
import { UserCredential } from '@angular/fire/auth';

@Injectable({ providedIn: 'root' })
export class DreamHackLoginService {

    constructor(private http: HttpClient) {
    }

    /**
     * Convert a DreamHack token into a custom Firebase login token
     * @param idToken DreamHack user id token
     * @returns LoginUser with custom token and user provider data from DreamHack
     */
    public async getCustomDreamHackToken(idToken: string): Promise<LoginUser> {
        // Connect to DreamHack server to verify token
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        });

        let rsp = await this.http.get<{ status: string, data: LoginUser }>(MotesPaths.MOTES_API_DREAMHACK_TOKEN, { headers: headers }).toPromise().catch((err) => {
            console.warn("Could not login in via DreamHack", err);
            throw "DreamHack Login Error: " + err?.message || "Unknown Error";
        });

        if(!rsp) return null;
        return rsp.data;
    }

    /**
     * Merge user provider data with login credentials to form LoginCredential object with auth token and user info
     * @param loginUser LoginUser with provider data
     * @param firebaseCredentials firebase credentials obtained by logging in with custom token or other means
     * @returns 
     */
    public async getLoginCredentials(loginUser: LoginUser, firebaseCredentials: UserCredential): Promise<LoginCredential> {
        // Obs: Unfortunately it seems we need to use the old school promise syntax here in order to actually return a promise that is not resolved (otherwise handleLogin doesn't seem to work)
        return new Promise((resolve) => {
            let login = firebaseCredentials as any as LoginCredential;
            // Pick only sub set of provider data for future usage
            let providerObject = (loginUser.providerData?.length > 0) ? loginUser.providerData[0] : [];
            let providerData = (({ id, avatar, email, first_name, last_name, birth_year, clan }) => ({ id, avatar, email, first_name, last_name, birth_year, clan }))(providerObject);

            // Augment firebase credentials with DreamHack info
            login.user = {
                uid: loginUser.uid,
                email: loginUser.email,
                displayName: loginUser.displayName,
                providerData: [providerData],
                photoURL: "", // Default DreamHack Photo is not valid - skip loginUser.photoURL,
                isAnonymous: false,

                getIdTokenResult: () => {
                    return Promise.resolve({
                        token: loginUser.token,
                        signInProvider: "DreamHack",
                        claims: { isAdmin: false },
                        authTime: null,
                        expirationTime: null,
                        issuedAtTime: null,
                        signInSecondFactor: null
                    })
                }
            };
            resolve(login);
        });
    }
}
